import { Box, BoxProps } from '@mui/material';  

interface RowProps extends BoxProps {
    children: React.ReactNode;
}

const Row: React.FC<RowProps> = ({ children, sx = {}, ...props }) => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'row', width: '100%', height: '100%', ...sx }} {...props}>
            {children}
        </Box>
    )
};

export default Row;